const MODEL_OUTPUT_CONTRACTS = {
  angulos: {
    boxes: 7,
    scores: 1,
    numDetections: 5,
    classes: 3
  }
};

const clamp01 = (value) => {
  if (!Number.isFinite(value)) return 0;
  return Math.min(1, Math.max(0, value));
};

const tensorToArray = async (tensor) => {
  if (!tensor || typeof tensor.data !== 'function') return [];
  const values = await tensor.data();
  return Array.from(values);
};

const normalizeBox = (boxes, offset) => {
  const yMin = clamp01(boxes[offset]);
  const xMin = clamp01(boxes[offset + 1]);
  const yMax = clamp01(boxes[offset + 2]);
  const xMax = clamp01(boxes[offset + 3]);

  const safeYMin = Math.min(yMin, yMax);
  const safeXMin = Math.min(xMin, xMax);
  const safeYMax = Math.max(yMin, yMax);
  const safeXMax = Math.max(xMin, xMax);

  const widthRatio = Math.max(0, safeXMax - safeXMin);
  const heightRatio = Math.max(0, safeYMax - safeYMin);

  return {
    yMin: safeYMin,
    xMin: safeXMin,
    yMax: safeYMax,
    xMax: safeXMax,
    widthRatio,
    heightRatio,
    areaRatio: widthRatio * heightRatio,
    centerX: safeXMin + widthRatio / 2,
    centerY: safeYMin + heightRatio / 2
  };
};

export const parseDetectionOutputs = async (modelName, outputs) => {
  if (!Array.isArray(outputs)) return null;

  const contract = MODEL_OUTPUT_CONTRACTS[modelName];
  if (!contract) return null;

  const boxesTensor = outputs[contract.boxes];
  const scoresTensor = outputs[contract.scores];
  const numDetectionsTensor = outputs[contract.numDetections];
  const classesTensor = outputs[contract.classes];

  if (!boxesTensor || !scoresTensor || !classesTensor) return null;

  const [boxes, scores, classes, numDetectionsValues] = await Promise.all([
    tensorToArray(boxesTensor),
    tensorToArray(scoresTensor),
    tensorToArray(classesTensor),
    tensorToArray(numDetectionsTensor)
  ]);

  const maxDetections = Math.min(
    scores.length,
    classes.length,
    Math.floor(boxes.length / 4)
  );

  const numDetections = Math.max(
    0,
    Math.min(
      maxDetections,
      Math.round(numDetectionsValues[0] || maxDetections)
    )
  );

  const detections = [];

  for (let index = 0; index < numDetections; index += 1) {
    const score = Number(scores[index] || 0);
    const classId = Number(classes[index] || 0);
    const box = normalizeBox(boxes, index * 4);

    detections.push({
      index,
      classId,
      score,
      ...box
    });
  }

  return {
    detections,
    scores,
    classes,
    boxes,
    numDetections
  };
};
